import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { Router } from '@angular/router';
import { DispoOrderTrainVisitModel } from '@railmybox/api-dispo';

@Component({
  selector: 'rmb-train-card-containers',
  templateUrl: './train-card-containers.component.html',
  styleUrl: './train-card-containers.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TrainCardContainersComponent {
  private router = inject(Router);

  readonly TRANSLOCO_PREFIX = 'capacity-management';
  @Input() dispoOrder: DispoOrderTrainVisitModel;
  @Input() isAdmin = true;

  goToDispoOrder() {
    if (this.isAdmin) {
      this.router.navigate([`/support/disposition/${this.dispoOrder.id}/details`]);
    } else {
      this.router.navigate([`/booking/${this.dispoOrder.bookingRef}/container-list`], {
        queryParams: { id: this.dispoOrder.bookingContainerKey },
      });
    }
  }
}
